export default "__VITE_ASSET__DwQ51IpC__"